import dependencies from "../authentication/dependencies";
import { NEW_BASE_URL, NEW_APPLICATION_CLIENT_ID } from "../config";
import v4 from "uuid/v4";
import { postJson } from "./apiErrors";
const { baseUrl, generalHeader } = dependencies;

export const createQuestionaireRequest = async (csrfToken, data, userId) => {
  const requestBody = {
    Header: {
      id: v4(),
      application: NEW_APPLICATION_CLIENT_ID,
      bank: "NBG",
      userId: userId || "123e4567-e89b-12d3-a456-426614174000",
    },
    Payload: {
      Title: data.title || null,
      Langcode: data.langcode || null,
      Status: data.status !== undefined ? data.status : null,
      Sticky: data.sticky !== undefined ? data.sticky : null,
      Promote: data.promote !== undefined ? data.promote : null,
      UrlAlias: data.urlAlias || null,
      Published: data.published !== undefined ? data.published : null,
      ProductCategories: data.productCategories || null,
      CompanyLegalName: data.companyLegalName || null,
      CompanyTaxNumber: data.companyTaxNumber || null,
      CompanyWebsite: data.companyWebsite || null,
      CompanyKad: data.companyKad || null,
      CompanyOwnsBankAccount:
        data.companyOwnsBankAccount !== undefined
          ? data.companyOwnsBankAccount
          : null,
      CompanyRepFullName: data.companyRepFullName || null,
      CompanyRepNumber: data.companyRepNumber || null,
      CompanyReprEmail: data.companyReprEmail || null,
      CompanyUsesErp:
        data.companyUsesErp !== undefined ? data.companyUsesErp : null,
      CompanyErpSolutionName: data.companyErpSolutionName || null,
      CompanyErpSolutionVersion: data.companyErpSolutionVersion || null,
      ErpBankingActivities: data.erpBankingActivities || null,
      CorporateUserId: data.corporateUserId || null,
      ConsentInformation:
        data.consentInformation !== undefined ? data.consentInformation : null,
      UserTypeId: data.userTypeId || null,
    },
  };

  return postJson(`${NEW_BASE_URL}/UserQuestionnaire/create`, {
    headers: generalHeader(csrfToken, true),
    body: requestBody,
    category: "userQuestionnaire/create",
  });
};
export const updateQuestionaireRequest = async (
  csrfToken,
  data,
  id,
  userId
) => {
  const requestBody = {
    Header: {
      id: v4(),
      application: NEW_APPLICATION_CLIENT_ID,
      bank: "NBG",
      userId: userId || "123e4567-e89b-12d3-a456-426614174000",
    },
    Payload: {
      Id: id,
      Title: data.title || null,
      Langcode: data.langcode || null,
      Status: data.status !== undefined ? data.status : null,
      Sticky: data.sticky !== undefined ? data.sticky : null,
      Promote: data.promote !== undefined ? data.promote : null,
      UrlAlias: data.urlAlias || null,
      Published: data.published !== undefined ? data.published : null,
      ProductCategories: data.productCategories || null,
      CompanyLegalName: data.companyLegalName || null,
      CompanyTaxNumber: data.companyTaxNumber || null,
      CompanyWebsite: data.companyWebsite || null,
      CompanyKad: data.companyKad || null,
      CompanyOwnsBankAccount:
        data.companyOwnsBankAccount !== undefined
          ? data.companyOwnsBankAccount
          : null,
      CompanyRepFullName: data.companyRepFullName || null,
      CompanyRepNumber: data.companyRepNumber || null,
      CompanyReprEmail: data.companyReprEmail || null,
      CompanyUsesErp:
        data.companyUsesErp !== undefined ? data.companyUsesErp : null,
      CompanyErpSolutionName: data.companyErpSolutionName || null,
      CompanyErpSolutionVersion: data.companyErpSolutionVersion || null,
      ErpBankingActivities: data.erpBankingActivities || null,
      CorporateUserId: data.corporateUserId || null,
      ConsentInformation:
        data.consentInformation !== undefined ? data.consentInformation : null,
      UserTypeId: data.userTypeId || null,
    },
  };

  return postJson(`${NEW_BASE_URL}/UserQuestionnaire/update`, {
    headers: generalHeader(csrfToken, true),
    body: requestBody,
    category: "userQuestionnaire/update",
  });
};

export const fetchAskForPlans = async (csrfToken, productId, userId) => {
  const requestBody = {
    Header: {
      id: v4(),
      application: NEW_APPLICATION_CLIENT_ID,
      bank: "NBG",
      userId: userId || "123e4567-e89b-12d3-a456-426614174000",
    },
    Payload: {
      Id: productId,
    },
  };

  const response = await fetch(`${NEW_BASE_URL}/Product/askForPlans`, {
    method: "POST",
    headers: generalHeader(csrfToken, true),
    credentials: "include",
    body: JSON.stringify(requestBody),
  });
  const result = await response.json();
  // The Core reports failures as HTTP 200 with an `exception` body; surface them as errors so
  // the modal does not thank the user for a request that was never sent.
  if (!response.ok || result?.exception) {
    throw new Error(
      result?.exception?.description || `HTTP ${response.status}`
    );
  }
  return result;
};

export const fetchQuestionaire = async (csrfToken, id) => {
  const response = await fetch(
    `${baseUrl}/jsonapi/node/user_questionnaire/${id}`,
    {
      headers: generalHeader(csrfToken),
      credentials: "include",
    }
  );
  return response.json();
};

export const fetchUserTypes = async (csrfToken) => {
  const requestBody = {
    Header: {
      id: v4(),
      application: NEW_APPLICATION_CLIENT_ID,
      bank: "NBG",
      userId: "123e4567-e89b-12d3-a456-426614174000",
    },
    Payload: {
      PageLimit: 10,
      PageOffset: 0,
      SortField: "Name",
      SortOrder: "ASC",
    },
  };

  const response = await fetch(`${NEW_BASE_URL}/UserType/list`, {
    method: "POST",
    headers: generalHeader(csrfToken, true),
    credentials: "include",
    body: JSON.stringify(requestBody),
  });
  return response.json();
};
